import { IMetric } from "@dto/architecture.dto";
import { ModalFuncProps } from "antd";
import { FC, useState } from "react";
import { XmModal } from "src/component/modal/XmModal";
import { XmSelect } from "src/component/select/XmSelect";
import { UnitHelper, UnitOption } from "src/util/UnitHelper";

interface YaxisModalState extends ModalFuncProps {
  metric: IMetric;
  availableMetrics: IMetric[];
  onConfirm: (metric: IMetric) => Promise<void>;
  onCancel: () => void;
}

export const YaxisModal: FC<YaxisModalState> = ({ metric, availableMetrics, onConfirm, onCancel, ...props }) => {
  const [selectedMetric, setSelectedMetric] = useState(metric);
  const [availableMetricOptions] = useState(() => availableMetrics?.map(UnitHelper.metric2option));

  return <XmModal width={400} title="Select additional Y-axis metric" destroyOnHidden
    onOk={() => onConfirm(selectedMetric)}
    onCancel={(e) => {
      setSelectedMetric(metric);
      onCancel();
    }} {...props}>
    <XmSelect style={{ width: '100%' }} ignoreReadonly defaultValue={selectedMetric?.metric} allowClear={true}
      options={availableMetricOptions} placeholder="Select metric for right side Y-axis"
      onChange={(value, option: UnitOption<IMetric>) => setSelectedMetric(option?.base)}
    />
  </XmModal>;
};